<template>
  <div class="xc-page xc-page-sandwich">
    <div class="xc-page-main">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <!-- <router-link :to="$config.adminPath + '/device'">终端管理</router-link> -->
        <!-- <router-link :to="$config.adminPath + '/device'">终端列表</router-link> -->
        <a @click="close" style="cursor: pointer;">终端管理</a>
        <a @click="close" style="cursor: pointer;">终端列表</a>
        <a>终端详情</a>
      </div>

      <!-- 铺满 -->
      <div class="xc-row xc-s-flex change-label" style="overflow: hidden;">
        <div class="xc-card">
          <div class="xc-card-content">
            <div class="tab">
              <template v-for="(item,key) in ['基本信息','播放列表','增播日志','减播日志','策略信息','版本信息']">
                <div
                  class="tab-item"
                  :key="key"
                  :class="{ 'tab-active': key == tabIndex }"
                  @click="tabIndex = key"
                >{{item}}</div>
              </template>
            </div>
            <template v-if="tabIndex == 0">
              <div class="xc-info">
                <div class="xc-info-title">终端信息</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline padding-top8">
                    <xc-form-item label="终端序号：">
                      <div class="value">{{deviceDetail.deviceSerialNum}}</div>
                    </xc-form-item>
                    <xc-form-item label="终端MAC：">
                      <div class="value">{{deviceDetail.deviceMac}}</div>
                    </xc-form-item>
                    <xc-form-item label="设备型号：">
                      <div class="value">{{deviceDetail.model}}</div>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline padding-top8">
                    <xc-form-item label="终端状态：">
                      <div class="value">{{deviceDetail.deviceStatus}}</div>
                    </xc-form-item>
                    <xc-form-item label="设备IP：">
                      <div class="value">{{deviceDetail.lastReportIp}}</div>
                    </xc-form-item>
                    <xc-form-item label="设备分辨率：">
                      <div class="value">{{deviceDetail.resolvingPower}}</div>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline padding-top8">
                    <xc-form-item label="设备类型：">
                      <div class="value">
                        <p v-if="deviceDetail.deviceType == '' || deviceDetail.deviceType == null">无</p>
                        <p v-else>{{deviceDetail.deviceType}}</p>
                      </div>
                    </xc-form-item>
                    <xc-form-item label="终端尺寸：">
                      <div class="value">
                        <p v-if="deviceDetail.screenSize == '' || deviceDetail.screenSize == null">无</p>
                        <p v-else>{{deviceDetail.screenSize}}</p>
                      </div>
                    </xc-form-item>
                    <!-- <xc-form-item label="设备分辨率">
                      <input type="text" maxlength="255" class="xc-input" v-model="deviceDetail.resolvingPower">
                    </xc-form-item>-->
                    <xc-form-item label="终端名：">
                      <div class="value">
                        <p v-if="deviceDetail.deviceName == '' || deviceDetail.deviceName == null">无</p>
                        <p v-else>{{deviceDetail.deviceName}}</p>
                      </div>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="终端类型：">
                      <div class="value">
                        <p>{{deviceDetail.screenSize?deviceDetail.screenSize:'无'}}</p>
                      </div>
                    </xc-form-item>
                    <xc-form-item label="所属房间：">
                       <div class="value">
                        <p>{{deviceDetail.screenSize?deviceDetail.screenSize:'无'}}</p>
                      </div>
                    </xc-form-item>
                  </div>
                  <!-- <div class="xc-form-inline">
                    <xc-form-item label="终端名">
                      <input type="text" maxlength="255" class="xc-input" v-model="deviceDetail.deviceName">
                    </xc-form-item>
                    <xc-form-item label="终端IP">
                      <input type="text" maxlength="255" class="xc-input" v-model="deviceDetail.lastReportIp">
                    </xc-form-item>
                    <xc-form-item label="终端组">
                      <input type="text" maxlength="255" class="xc-input" v-model="deviceDetail.groupName">
                    </xc-form-item>
                  </div>-->
                </div>
              </div>

              <div class="xc-info">
                <div class="xc-info-title">终端位置信息</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item label="导入门店：">
                      <input
                        type="text"
                        maxlength="255"
                        class="xc-input xc-input-readonly"
                        style="border-width: 0;"
                        readonly
                        v-model="deviceDetail.storeName"
                      />
                    </xc-form-item>
                    <xc-form-item label="终端组：">
                      <input
                        type="text"
                        maxlength="255"
                        class="xc-input xc-input-readonly"
                        style="border-width: 0;"
                        readonly
                        v-model="deviceDetail.groupName"
                      />
                    </xc-form-item>
                    <xc-form-item label="楼栋：">
                      <div class="value">
                        <p v-if="deviceDetail.building == '' || deviceDetail.building == null">无</p>
                        <p v-else>{{deviceDetail.building}}</p>
                      </div>
                    </xc-form-item>
                  </div>
                  <div class="xc-form-inline">
                    <xc-form-item label="单元：">
                      <div class="value">
                        <p v-if="deviceDetail.unit == '' || deviceDetail.unit == null">无</p>
                        <p v-else>{{deviceDetail.unit}}</p>
                      </div>
                    </xc-form-item>
                    <xc-form-item label="楼层：">
                      <div class="value">
                        <p v-if="deviceDetail.floor == '' || deviceDetail.floor == null">无</p>
                        <p v-else>{{deviceDetail.floor}}</p>
                      </div>
                    </xc-form-item>
                    <xc-form-item label="安装位置：">
                      <div class="value">
                        <p v-if="deviceDetail.position == '' || deviceDetail.position == null">无</p>
                        <p v-else>{{deviceDetail.position}}</p>
                      </div>
                    </xc-form-item>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="tabIndex == 1">
              <div class="xc-info">
                <!-- <div class="xc-info-title">播放列表</div> -->
                <div class="xc-info-content">
                  <table class="xc-table">
                    <thead>
                      <tr>
                        <th>节目名称</th>
                        <th>素材名称</th>
                        <th>播放时长</th>
                        <th>创建时间</th>
                        <th>下放时间</th>
                        <th>投放开始时间</th>
                        <th>投放结束时间</th>
                        <th>累计播放次数</th>
                        <th>累计播放时长</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="list && list.length">
                        <tr v-for="(item,key) in list" :key="key">
                          <td>{{item.programName}}</td>
                          <td>{{item.fileName}}</td>
                          <td>{{((item.duration)/1000).toFixed(2)}}秒</td>
                          <td>{{item.addTime}}</td>
                          <td>{{item.pushTime}}</td>
                          <td>{{item.putinStartTime}}</td>
                          <td>{{item.putinEndTime}}</td>
                          <td>{{item.playCount}}次</td>
                          <td>{{item.playDuration}}</td>
                          <td>
                            <div class="xc-link">
                              <a @click="action('delete',item,$event)">删除</a>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="10" class="xc-s-tac">暂无数据</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>

            <template v-if="tabIndex == 2">
              <div class="xc-info">
                <!-- <div class="xc-info-title">增播日志</div> -->
                <div class="xc-info-content">
                  <table class="xc-table">
                    <thead>
                      <tr>
                        <th>素材名称</th>
                        <th>增播开始时间</th>
                        <th>播放时长</th>
                        <th>操作人</th>
                        <th>操作时间</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="programAddLog && programAddLog.length">
                        <tr v-for="(item,key) in programAddLog" :key="key">
                          <td>{{item.fileName}}</td>
                          <td>{{item.putinStartTime}}</td>
                          <td>{{((item.duration)/1000).toFixed(2)}}秒</td>
                          <td>{{item.optUserRealName}}</td>
                          <td>{{item.addTime}}</td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="9" class="xc-s-tac">暂无数据</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>

            <div class="xc-info" v-show="tabIndex == 3">
              <!-- <div class="xc-info-title">减播日志</div> -->
              <div class="xc-info-content">
                <table class="xc-table">
                  <thead>
                    <tr>
                      <th>素材名称</th>
                      <th>操作人</th>
                      <th>操作时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="programReducedLog && programReducedLog.length">
                      <tr v-for="(item,key) in programReducedLog" :key="key">
                        <td>{{item.sourceName}}</td>
                        <td>{{item.addUserName}}</td>
                        <td>{{item.addTime}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="9" class="xc-s-tac">暂无数据</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="xc-info" v-show="tabIndex == 4">
              <!-- <div class="xc-info-title">策略信息</div> -->
              <div class="xc-info-content">
                <table class="xc-table">
                  <thead>
                    <tr>
                      <th>定时开关机</th>
                      <th v-if="deviceDetail.bootFlag">开机时间</th>
                      <th v-if="deviceDetail.bootFlag">关机时间</th>
                      <th>音量</th>
                      <th>最近连接时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{deviceDetail.bootFlag?'开启':'关闭'}}</td>
                      <td v-if="deviceDetail.bootFlag">
                        <div
                          v-if="limitCheck"
                        >工作日{{deviceDetail.timeBoot}}/周末{{deviceDetail.timeBootNonWorkDay}}</div>
                        <div v-else>{{deviceDetail.timeBoot}}</div>
                      </td>
                      <td v-if="deviceDetail.bootFlag">
                        <div
                          v-if="limitCheck"
                        >工作日{{deviceDetail.timeShutdown}}/周末{{deviceDetail.timeShutdownNonWorkDay}}</div>
                        <div v-else>{{deviceDetail.timeShutdown}}</div>
                      </td>
                      <td>{{deviceDetail.deviceVolume}}</td>
                      <td>{{deviceDetail.lastReportTime}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="xc-info" v-show="tabIndex == 5">
              <!-- <div class="xc-info-title">版本信息</div> -->
              <div class="xc-info-content">
                <table class="xc-table">
                  <thead>
                    <tr>
                      <th>MIPS版本</th>
                      <th>MIPS升级时间</th>
                      <th>固件版本</th>
                      <th>固件升级时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{deviceDetail.softwareVersion}}</td>
                      <td>{{deviceDetail.softwareUpgradeTime}}</td>
                      <td>{{deviceDetail.firmwareVersion}}</td>
                      <td>{{deviceDetail.firmwareUpgradeTime}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 固低栏 -->
    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <!-- <router-link class="xc-btn xc-btn-default" :to="this.$config.adminPath + '/device'">返回</router-link> -->
        <a class="xc-btn xc-btn-default" @click="close">返回</a>
        <div class="xc-btn xc-btn-primary" @click="showDialog">编辑</div>
        <!-- @click="deviceUpdata" v-if="tabIndex == 0" -->
      </div>
    </div>

    <!-- 弹出终端编辑窗口 -->
    <div class="xc-modal xc-modal-dialog change-label" v-if="dialogName == 'edit'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">编辑终端</div>
          </div>
          <div class="xc-info xc-modal-body">
            <div class="xc-info-title">终端信息</div>
            <div class="xc-info-content">
              <div class="xc-form-inline padding-top8">
                <xc-form-item label="终端序号：">
                  <div class="value">{{dialogData.deviceSerialNum}}</div>
                </xc-form-item>
                <xc-form-item label="终端MAC：">
                  <div class="value">{{dialogData.deviceMac}}</div>
                </xc-form-item>
                <xc-form-item label="设备型号：">
                  <!-- <div class="value">{{dialogData.model}}</div> -->
                  <input
                    type="text"
                    maxlength="255"
                    class="xc-input"
                    v-model="dialogData.model"
                    placeholder="请输入设备型号"
                  />
                </xc-form-item>
              </div>
              <div class="xc-form-inline padding-top8">
                <xc-form-item label="终端状态：">
                  <div class="value">{{dialogData.deviceStatus}}</div>
                </xc-form-item>
                <xc-form-item label="设备IP：">
                  <div class="value">{{dialogData.lastReportIp}}</div>
                </xc-form-item>
                <xc-form-item label="设备分辨率：">
                  <div class="value">{{dialogData.resolvingPower}}</div>
                </xc-form-item>
              </div>
              <div class="xc-form-inline padding-top8">
                <xc-form-item label="设备类型：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.deviceType"
                    placeholder="请输入设备类型"
                  />
                </xc-form-item>
                <xc-form-item label="终端尺寸：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.screenSize"
                    placeholder="请输入终端尺寸"
                  />
                </xc-form-item>
                <xc-form-item label="终端名：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.deviceName"
                    placeholder="请输入终端名"
                  />
                </xc-form-item>
              </div>
            </div>
          </div>
          <div class="xc-info xc-modal-body">
            <div class="xc-info-title">终端位置信息</div>
            <div class="xc-info-content">
              <div class="xc-form-inline">
                <xc-form-item label="导入门店：">
                  <input
                    type="text"
                    maxlength="255"
                    class="xc-input xc-input-readonly"
                    style="border-width: 0;"
                    readonly
                    v-model="deviceDetail.storeName"
                  />
                </xc-form-item>
                <xc-form-item label="终端组：">
                  <input
                    type="text"
                    maxlength="255"
                    class="xc-input xc-input-readonly"
                    style="border-width: 0;"
                    readonly
                    v-model="deviceDetail.groupName"
                  />
                </xc-form-item>
                <xc-form-item label="楼栋：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.building"
                    placeholder="请输入相应的楼栋"
                  />
                </xc-form-item>
              </div>
              <div class="xc-form-inline">
                <xc-form-item label="单元：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.unit"
                    placeholder="请输入相应的单元"
                  />
                </xc-form-item>
                <xc-form-item label="楼层：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.floor"
                    placeholder="请输入相应的楼层"
                  />
                </xc-form-item>
                <xc-form-item label="安装位置：">
                  <input
                    type="text"
                    maxlength="20"
                    class="xc-input"
                    v-model="dialogData.position"
                    placeholder="请输入相应的安装位置"
                  />
                </xc-form-item>
              </div>
            </div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="dialogName = null">取消</div>
              <div class="xc-btn xc-btn-primary" @click="deviceUpdata" v-if="tabIndex == 0">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import mixin from "../xc-ui/mixins/list";
import deviceApi from "../api/device";
import nullToStr from "../utils/null-tostring";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [mixin],
  name: "deviceDetail",

  data() {
    return {
      isTiming: true,
      limitCheck:true,
      deviceDetail: null,
      deviceCode: this.$route.params.deviceCode,

      // 弹出框
      dialogName: null,
      dialogData: null,

      // 列表key
      mix_listKey: "list",

      // 播放列表
      list: [],

      // 增播日志列表
      addPlay: [],

      // 减播日志列表
      programReducedLog: [],
      programAddLog: [],

      // 选项卡
      tabIndex: 0
    };
  },

  computed: {
    ...mapState(["globalConfig"]),
    // 是否开启周么时间限制
    // limitCheck() {
    //   if(this.globalConfig.bootTimeDiff){
    //     if (this.globalConfig && this.globalConfig.bootTimeDiff.value == "true") {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   }
      
    // }
  },

  created() {
    // 获取全局值
    // this.deviceInfo = JSON.parse(sessionStorage.getItem('deviceInfo'))

    // 获取终端详情
    deviceApi
      .getDeviceDetail({ deviceCode: this.$route.params.deviceCode })
      .then(v => {
        this.deviceDetail = nullToStr(v.data);
      });

    // 节目减播日志列表
    this.programReducedLogFun();

    // 获取增播日志列表
    this.getAddedSourcesByDeviceCode();
  },

  mounted() {},

  methods: {
    // 节目减播日志列表
    programReducedLogFun() {
      let that = this;
      deviceApi
        .programReducedLog({ deviceCode: that.$route.params.deviceCode })
        .then(v => {
          that.programReducedLog = v.data;
        });
    },

    // 获取增播日志列表
    getAddedSourcesByDeviceCode() {
      let that = this;
      deviceApi
        .getAddedSourcesByDeviceCode({
          deviceCode: that.$route.params.deviceCode
        })
        .then(v => {
          that.programAddLog = v.data;
        });
    },

    // 初始化数据
    initData(v) {
      // 默认搜索的数据
      const search = {
        ...this.mix_query,
        deviceCode: this.$route.params.deviceCode
      };

      deviceApi.getCurrentSourcesByDeviceCode(search).then(v => {
        let ret = v;
        this.list = this.mix_format(ret.data);
        // {{((item.playDuration)/1000/60).toFixed(2) > 1
        for (let item of ret.data) {
          if (item.playDuration / 1000 / 60 > 1) {
            let F = parseInt(item.playDuration / 1000 / 60);
            item.playDuration =
              F +
              "分" +
              ((item.playDuration / 1000 / 60 - F) * 60).toFixed(0) +
              "秒";
          } else {
            item.playDuration = (item.playDuration / 1000).toFixed(0) + "秒";
          }
        }
      });
    },

    // 操作单条数据
    action(...args) {
      let that = this;
      const [action, item, index] = args;
      const e = args[args.length - 1];

      switch (action) {
        // 节目减播
        case "delete":
          this.$xc
            .confirm({
              title: "删除提示",
              msg: "确定删除该素材？删除后终端将不再播放该素材"
            })
            .then(v => {
              let arr = [];
              arr.push(item);
              // 获取sourceJson参数
              let sourceJson = JSON.stringify(arr);
              deviceApi.programReduce(this.deviceCode, sourceJson).then(v => {
                that.programReducedLogFun();
                that.initData();
                // 后台删除成功后调用
                this.mix_delete(item);
              });
            });

          break;
        default:
          break;
      }
    },

    deviceUpdata() {
      // 修改详情
      deviceApi
        .getDeviceUpdate({
          ...nullToStr(this.dialogData),
          deviceCode: this.$route.params.deviceCode
        })
        .then(v => {
          this.deviceDetail = {
            ...this.dialogData
          };

          // 后台删除成功后调用
          this.$message.success("保存成功");
          this.dialogName = null;
        });
    },

    //预览素材
    viewMaterial(e) {
      let data = e.target.dataset;

      var program = {
        name: data.filename,
        type: data.filetype,
        url: data.url
      };

      myLayer.open({
        type: 2,
        title: false,
        shadeClose: true,
        closeBtn: 0, //不显示关闭按钮
        area: ["981px", "550px"],
        content:
          "/admin/material/preview?name=" +
          program.name +
          "&type=" +
          program.type +
          "&url=" +
          program.url,
        success: function(layero, index) {}
      });
    },

    showDialog() {
      this.dialogName = "edit";
      this.dialogData = {
        ...this.deviceDetail
      };
    },

    close: function () {
        parent.myLayer.close(this.index);

    }
  },
  async mounted() {
    await myLayerImport();
    this.index = parent.myLayer.getFrameIndex(window.name);
  }
};
</script>

<style lang="scss">
@import "../xc-ui/scss/variable";
.change-label .#{$xc-prefix}-form-item-label {
  min-width: 75px;
}
</style>

<style scoped lang="scss">
@import "../xc-ui/scss/variable";
td {
  height: 41px;
}

.tab {
  position: relative;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  margin-bottom: 25px;
  .tab-item {
    margin: 0;
    border: 1px solid #e8e8e8;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    background: #fafafa;
    margin-right: 2px;
    padding: 0 16px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    line-height: 38px;
  }
  .tab-active {
    background: #fff;
    position: relative;
    color: $xc-bg;
    &:before {
      width: 100%;
      height: 1px;
      top: 100%;
      background: #fff;
      content: "";
      position: absolute;
      left: 0;
      z-index: 1;
    }
  }
}

.value {
  width: 160px;
  line-height: 30px;
  padding: 0 10px;
}
</style>
